import React, { useContext, useState } from 'react';
import { symptoms, symptomCodes } from '@mummssoftware/utils';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { Tooltip } from '@material-ui/core';
import { useTheme, createStyles, makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { CodeTooltip } from './CodeTooltip';
import {
  SymptomRowDiv,
  SymptomLabelDiv,
  FlexRow,
  FlexColum,
  SIATitleDiv,
  SIAStatementDiv,
} from './HOPEWrappers';
import defaults from '../../translations/en.json';

const SymptomRow = ({ symptom, stateSIA, updateSIA }: any) => {
  const [letterValue, displayValue] = symptoms[symptom];
  const codes = Object.keys(symptomCodes);
  const symptomSelected = stateSIA[symptom];
  const symptomRequiresSFV = symptomSelected > 1 && symptomSelected < 4;

  const { palette } = useTheme();
  let labelColor: string;

  if (symptomSelected) {
    if (symptomRequiresSFV) {
      labelColor = palette.text.secondary;
    } else {
      labelColor = palette.text.primary;
    }
  } else {
    labelColor = (palette.text as any).grey;
  }
  const isTopRow = symptom === 'pain';

  const useStyles = makeStyles((theme) =>
    createStyles({
      root: {
        flexWrap: 'nowrap',
        paddingLeft: '5px',
      },
    }),
  );
  const classes = useStyles();

  const RadioItem = ({ code }: any) => {
    const codeTextValue = symptomCodes[code];

    let radioColor: string;

    if (symptomSelected && symptomSelected !== code) {
      if (symptomRequiresSFV) {
        radioColor = palette.text.secondary;
      } else {
        radioColor = palette.text.primary;
      }
    } else {
      radioColor = palette.text.primary;
    }
    const useRadioStyles = makeStyles((theme) =>
      createStyles({
        smallRadioButton: {
          '& svg': {
            width: '0.75em',
            height: '0.75em',
            color: radioColor,
          },
        },
        label: {
          margin: '2px',
          color: palette.text.primary,
        },
      }),
    );
    const radioClasses = useRadioStyles();
    const borderStyle =
      ((code === '1' || code === '3') && { borderRight: 'solid black 1px' }) ||
      {};
    return (
      <div style={borderStyle}>
        <Tooltip
          title={codeTextValue}
          placement="bottom-start"
          open={isTopRow ? undefined : false}
        >
          <FormControlLabel
            key={symptom}
            value={code}
            control={
              <Radio
                key={`${symptom}-${code}`}
                size="small"
                className={radioClasses.smallRadioButton}
              />
            }
            label={isTopRow ? code : ''}
            labelPlacement="top"
            className={radioClasses.label}
          />
        </Tooltip>
      </div>
    );
  };

  return (
    <SymptomRowDiv symptom={symptom}>
      <SymptomLabelDiv color={labelColor}>
        {`${letterValue}. ${displayValue}`}
      </SymptomLabelDiv>
      <RadioGroup
        value={stateSIA[symptom] || ''}
        onChange={(event: any) => updateSIA(event, symptom)}
        row
        className={classes.root}
      >
        {codes.map((code: any) => (
          <RadioItem code={code} />
        ))}
      </RadioGroup>
    </SymptomRowDiv>
  );
};

export const SIAContent = ({
  currentMilestone,
  stateSIA,
  updateSIA,
  isSFV,
  SIAMessage,
  questionNumber,
}: any) => {
  const symptomKeys = Object.keys(symptoms);

  return (
    <div>
      <FlexRow>
        <FlexColum style={{ paddingRight: '10px' }}>
          <SIATitleDiv>{`${(isSFV && 'SFV ') || `${currentMilestone} `}${
            defaults.symptomImpact
          }`}</SIATitleDiv>
          <FlexRow>
            <SIATitleDiv>{questionNumber}</SIATitleDiv>
            <CodeTooltip />
          </FlexRow>
          <SIAStatementDiv>{SIAMessage}</SIAStatementDiv>
        </FlexColum>
        <FlexColum>
          {symptomKeys.map((symptom: any) => (
            <SymptomRow
              key={symptom}
              symptom={symptom}
              stateSIA={stateSIA}
              updateSIA={updateSIA}
            />
          ))}
        </FlexColum>
      </FlexRow>
    </div>
  );
};
